import { useIdioma } from '../../context/IdiomaContext';

import './Cookies.css';

function Cookies() {
  const { t } = useIdioma();

  const cookiesUtilizadas = t(
    'cookies.utilizadas.parrafos'
  );

  const serviciosTerceros = t(
    'cookies.terceros.parrafos'
  );

  return (
    <main className="pagina-legal">
      <article className="legal-contenido">
        <header className="legal-encabezado">
          <p className="legal-etiqueta">
            {t('cookies.etiqueta')}
          </p>

          <h1>{t('cookies.titulo')}</h1>

          <p>
            {t(
              'cookies.ultimaActualizacion'
            )}
          </p>
        </header>

        <section>
          <h2>
            {t('cookies.definicion.titulo')}
          </h2>

          <p>
            {t(
              'cookies.definicion.descripcion'
            )}
          </p>
        </section>

        <section>
          <h2>
            {t('cookies.utilizadas.titulo')}
          </h2>

          {cookiesUtilizadas.map(
            (parrafo, index) => (
              <p key={index}>{parrafo}</p>
            )
          )}
        </section>

        <section>
          <h2>
            {t('cookies.terceros.titulo')}
          </h2>

          {serviciosTerceros.map(
            (parrafo, index) => (
              <p key={index}>{parrafo}</p>
            )
          )}
        </section>

        <section>
          <h2>
            {t('cookies.gestion.titulo')}
          </h2>

          <p>
            {t(
              'cookies.gestion.descripcion'
            )}
          </p>
        </section>

        <section>
          <h2>
            {t('cookies.futuro.titulo')}
          </h2>

          <p>
            {t(
              'cookies.futuro.descripcion'
            )}
          </p>
        </section>

        <section>
          <h2>
            {t('cookies.contacto.titulo')}
          </h2>

          <p>
            {t(
              'cookies.contacto.descripcion'
            )}{' '}

            <a href="mailto:contacto@jmmartinlabs.com">
              contacto@jmmartinlabs.com
            </a>
            .
          </p>
        </section>
      </article>
    </main>
  );
}

export default Cookies;